module.exports = __webpack_public_path__ + "img/ae_logo.93e645be.jpg";